import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
interface NotificationProps {
  message: string;
  messageType: string;
  setIsOpen: (open: boolean) => void;
  isOpen: boolean; // Provide a type for the message prop
}
export default function Notification({
  message,
  messageType,
  setIsOpen,
  isOpen,
}: NotificationProps) {
  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className={"pointer-events-none fixed top-0 z-50 right-0 flex items-end px-4 py-6 sm:items-start sm:p-6 "+(!isOpen && 'hidden')}
      >
        <div className={"pointer-events-auto z-50 w-full max-w-sm overflow-hidden rounded-md shadow-lg ring-1 ring-black ring-opacity-5 "
          + (messageType === "success" && 'bg-green-500 border-l-8 border-green-600 ') + (messageType === "error" && ' bg-red-500 border-l-8 border-red-600 ')}>
          <div className="py-4 px-2">
            <div className="flex items-center">
              <div className="flex w-full flex-1 justify-between">
                <p className="flex-1 tracking-wide font-medium text-white">
                  {message}
                </p>
                {/* <button
                      type="button"
                      className="ml-3 flex-shrink-0 rounded-md bg-white text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Undo
                    </button> */}
                <div className="ml-4 flex flex-shrink-0">
                  <button
                    type="button"
                    className="inline-flex rounded-md text-gray-50 hover:text-gray-100 focus:outline-none"
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
